/**
 * This file contains constants related to product options.
 *
 * All constants should be UPPERCASE.
 * All constants should be defined as const rather than let
 * All constants should be in alphabetical order.
 * All constants should be exported so other files can easily use them.
 *
 * In ES6 and onward, semicolons are optional. They have been omitted in this file.
 */

export const FREE_CANVAS = 'CP-CAN-8X8-0000-001'
export const FREE_MAGNET = 'CP-MAG-3X2-0000-001'
export const FREE_MAGNET_2 = 'CP-MAG-2X3-0000-001'
export const FREE_MUG = 'CP-MUG-BASIC-0000-001'
export const FREE_PHOTOS = 'CP-PHOTOS-4X6-0000-001'
export const FREE_PHOTOS_2 = 'CP-PHOTOS-6X4-0000-001'
export const FREE_STICKER = 'CP-STK25-CIRC-2X2-001'
export const FREE_TOTE = 'CP-TOTE-BASIC-0000-001'

// Array of all free products
export const FREE_SKUS = [
  FREE_CANVAS,
  FREE_MAGNET,
  FREE_MAGNET_2,
  FREE_MUG,
  FREE_PHOTOS,
  FREE_PHOTOS_2,
  FREE_STICKER,
  FREE_TOTE
]
